
const alertTypes = {
  OK: 1,
  OK_CANCEL: 2,
  YES_NO: 3,
  CUSTOM: 4
};

export default alertTypes;



// WEBPACK FOOTER //
// ./src/consts/alertTypes.js